import {
    UPDATE_BREAST,
    GET_BREAST_TOTAL_SUCCESS,
    GET_BREAST_TOTAL_FAIL,
  } from "../actions/_actionType";
  // "service/actions/_actionType";
  export default function breastRe(
    state = {
        breastData: {
        age: 45,
        sex: false,
        kg: 60,
        cm: 160,
        dmyn: false,
        hbp: false,
        dyslip: false,
        brsmoking: false,
        drinking: false,
        exercise: false,
        childbirth: 0,
        breastFeeding: 0,
        mensesAge: 13,
        tumor: 0,
        bpd: 0,
        menopause: 0,
        bcfmh: false,
      },
      total: 0,
      complete: false,
    },
    action
  ) {
    switch (action.type) {
      case UPDATE_BREAST:
        return {
          ...state,
          breastData: action.payload.datas,
        };
      case GET_BREAST_TOTAL_SUCCESS:
        return {
          ...state,
          total: action.total,
          complete: true,
        };
      case GET_BREAST_TOTAL_FAIL:
        return {
          ...state,
          total: action.total,
          complete: true,
        };
  
      default:
        return state;
    }
  }
  